import { StandardListEntity } from '../../../model/entity/standard-list-entity';
import { Factory } from './factory';
import { QuickFactory } from './quick-factory';

type StandardListEntitySettings = {
  idField?: string;
  labelField?: string[];
  displayId?: boolean;
  displayLabel?: boolean;
  colorField?: string;
};

export class StandardListEntityFactory
  extends QuickFactory
  implements Factory<StandardListEntity>
{
  private api = '';
  private settings: StandardListEntitySettings = {
    idField: 'id',
    labelField: ['label'],
    displayId: true,
    displayLabel: true,
  };

  private get display(): 'full' | 'id' | 'label' {
    return this.settings.displayId && this.settings.displayLabel
      ? 'full'
      : this.settings.displayLabel
        ? 'label'
        : 'id';
  }

  constructor(api: string, settings: StandardListEntitySettings = {}) {
    super();
    this.api = api;
    this.settings.idField = settings.idField || 'id';
    this.settings.labelField = settings.labelField || ['label'];
    this.settings.displayId =
      settings.displayId !== undefined ? settings.displayId : true;
    this.settings.displayLabel =
      settings.displayLabel !== undefined ? settings.displayLabel : true;
    this.settings.colorField = settings.colorField || null;
  }

  build(o: any): StandardListEntity {
    const label = this.settings.labelField.map((l) => o[l]).join(' ');
    const e = new StandardListEntity(
      o[this.settings.idField],
      label,
      o.items?.map((item: any) => this.build(item)) ?? [],
    );
    e.display = this.display;
    if (this.settings.colorField) {
      e.icon = 'square icon-bold';
      e.iconColor = o[this.settings.colorField];
    }
    this.generateProperty(e, o);
    return e;
  }

  getApi(): string {
    return this.api;
  }
}
